export const featureFlagsFinance:Record<string, boolean> = {
  
}
